<template>        
    <v-row class="ma-0" v-if="projectName !== 'SmartLinkRAOS'">
        <v-col class="pa-0" cols="12" sm="12" md="12" lg="12" xl="12" xxl="12">
            <v-card class="ma-4 pa-4 mb-0 mt-0 py-0" style="border-radius: 10px;" elevation="0" color="bgtopology">
                <v-card-title>
                    <v-row justify="space-between" class="ma-0" style="align-items: center;">
                        <span class="titleDashboard"> {{ t('labels.linkMap') }} </span>                           
                        <v-progress-circular
                        class="circular_btn"
                        :rotate="360"
                        :size="25"
                        :width="5"
                        :model-value="valorCount"
                        color="bgCircular"
                        @click="restarInfo()"
                        />
                    </v-row>                             
                </v-card-title>
                <v-card-text class="pr-0" :class="statusEquips.length > 0 ? '' : 'text-center'">                        
                    <NetworkChart
                    v-if="showNetWork"
                    />
                    <Prog_circular v-else/>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>

    <v-row class="ma-0">
        <v-col cols="12" class="pa-0">
            <KPICOMPONENT v-if='showKPI' :recharge="changeKPIData" :countEquipStatus='countEquipStatus'/>
        </v-col>
    </v-row>
    
    <v-row class="ma-0">
        
        <v-col cols="12" class="pa-0 ">
            <v-sheet v-if="showVirMac" class="defaultCard" color="bgtopology" >
                <span class="ml-4 titleDashboard">{{ t('sidebar.servers') }}</span>
                <VirtualMachines 
                v-if="ipVIRMAC.length > 0"               
                :ip="ipVIRMAC"
                :recharge="changeMVSData"
                :emited="false"
                :rows=7
                />
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script setup lang="ts">
import { Ref,  onBeforeUnmount, onMounted, ref, computed } from 'vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ********** COMPONENTS **********
 *******************************/
import NetworkChart from '@/components/SmartLink/maps/NetworkChart.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';
import KPICOMPONENT from '@/components/SmartLink/dashboard/KPI-Component.vue';
import VirtualMachines from '@/components/SmartLink/server - lte/VirMacDialog.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { SystemStatus} from '@/interfaces/SmartLink/Equips';
import { TOPO_GENERAL,} from '@/interfaces/SmartLink/Topology';

/********************************
 *********** SERVICES ***********
 *******************************/
import { getAllStatusData } from '@/services/Smartlink/Principal';
import { getIPServerData } from '@/services/Smartlink/Server';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from '@/constants/labels';

/**
 * se obtiene el nombre del proyecto desde el store
 */
const projectName = computed(() => store.state.projectName);

/**
 * Intervalo de recarga de datos
 * Si es SmartLinkDEMO: 15 minutos (1/3)
 * Si es otro proyecto: 1 minutos (10/6)
 */
const INTERVALRECARGE = projectName.value === 'SmartLinkDEMO' ? (1/3) : (10/6)

/**
 * Valores del mapa Traídos de la API
 */
const statusEquips:Ref<TOPO_GENERAL[]>      = ref([]);  

/**
 * Objeto con la cantidad de estados según el subtipo
 */
const countEquipStatus:Ref<SystemStatus>    = ref({
    distri: { ok: 0, alarm: 0, alert: 0, down: 0},
    acceso: { ok: 0, alarm: 0, alert: 0, down: 0},
    client: { ok: 0, alarm: 0, alert: 0, down: 0},
});

/**
 * Muestra El componente de Network (Mapa) si desde la API
 * traen información
 */
const showNetWork   = ref(true);

/**
 * Muestra El componente de KPI si desde la API
 * traen información
 */
const showKPI       = ref(false);  


/**
 * Captura toda la info de la API: "getAllTopologyData"
 * lo almacena en la variable "statusEquips".
 * Calcula la cantidad de equipos en según que estados,
 * filtrando por su familia, lo almacena en "countEquipStatus"
 */
async function getStatusData(){

    const allData = await getAllStatusData()
    
    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        countEquipStatus.value = allData.data.countEquipData
        statusEquips.value = allData.data.statusEquipData
    }
    showKPI.value = allData.showGraphs
    // showNetWork.value = allData.showGraphs
}

/**
 * Para recargar el Componente KPI
 */
const changeKPIData = ref(true);

/**
 * Para recargar el Componente Virtual Machine
 */
const changeMVSData = ref(true);

/**
 * Valor numérico del ciclo 
 */
const valorCount = ref(0);

/**
 * Valor final del INVERVALOR para el reset de la data
 */
const interval = ref();

/**
 * Se activa cada 15 minutos (1 minuto si no es DEMO) o cuando le das click al círculo en la parte superior derecha del mapa.
 * Recarga la infomación de los componentes hijos. (KPI y Virtual Machine)
 */
async function restarInfo(){
    
    changeKPIData.value = false;
    changeMVSData.value = false;
    showKPI.value = false;
    // showNetWork.value = false;
    valorCount.value    = 0;

    statusEquips.value  = [];
        
    getStatusData();
    getIpVirMac();

    // Hay un delay de 100ms para la carga de data
    setTimeout(()=> {
        changeKPIData.value = true;
        changeMVSData.value = true;
        showKPI.value = true;
        showNetWork.value = true;

    },100)
}


/**
 * Muestra El componente de Virtual Machine si desde la API
 * traen información
 */
const showVirMac    = ref(true);

/**
 * Array de IP de los servidores
 */
const ipVIRMAC:Ref<string[]> =    ref([])

/**
 * Consulta la API: "getIPServer"
 * Captura las IPs de los equipos de TIPO: SERVIDOR/SERVER
 * lo almacena en el ARRAY: "ipVIRMAC"
 */
async function getIpVirMac() { 

    const allData = await getIPServerData()

    showVirMac.value = allData.showGraphs
    
    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        ipVIRMAC.value = allData.data
    }
}

/**
 * Cuando se desmonta el componente (cuando le das a otra vista)
 * se reinicia el intervalo
 */
onBeforeUnmount(() => {
    clearInterval(interval.value)
}),

onMounted( async() => {
    
    getStatusData();   
    getIpVirMac();       

    /**
     * Crea un intervalo que dura 1 minuto
     * Cuando llega a 1 minuto, llama a la función "restarInfo()"
     * (15 minutos cuando se trata de SmartLinkDEMO)
     */
    interval.value = setInterval(async()=>{
        if(valorCount.value > 100 ){ 
            await restarInfo(); 
        }
        valorCount.value += INTERVALRECARGE;
    },1000)
})

</script>

<style>

.cardSingleKPI{
    cursor: pointer;
}

.btnKPI{
    border-radius: 5px;
}

.mapdiv {
    border-radius: 10px !important;
}

.dashboard-card .v-btn--active{
    background-color: rgb(var(--v-theme-btnSelect)) !important;
}

/* .dashboard-card .titleDashboard{
    font-family: 'Tilt Warp',sans-serif;
    font-size: 30px;
} */
 
.borderMap{
    border-radius: 10px !important;
}

.defaultCard{
    border-radius: 10px !important;
    padding: 16px !important;
    margin: 16px !important;
}

.textappBAR{    
  font-weight: bold;
  text-transform: capitalize !important;
  font-size: 19px !important;  
  font-family: 'Poppins', sans-serif;
  letter-spacing: 5px;
}

.titleDashboard{
    font-family: 'Poppins',sans-serif;
    font-size: 30px;
    font-weight: 400;
    color: rgb(var(--v-theme-colorText));
}

.subtitleDashboard{
    font-family: 'Poppins',sans-serif;
    font-size: 20px;
    font-weight: 300;
    color: rgb(var(--v-theme-colorText));
}

.textDashboard{
    font-family: 'Poppins',sans-serif;
    font-size: 14px;
    color: rgb(var(--v-theme-colorText));
}

.textblackDashboard{
    font-family: 'Poppins',sans-serif;
    font-size: 14px;
    color: black;
}

.btnSuccessDashboard{
    background-color: #0098f0 !important;
    background-image: linear-gradient(to bottom left, #00f2c3, #0098f0,#00f2c3) !important;
    border-radius: 5px;
    transition: .3s ease-in-out;
}
.btnSuccessDashboard:hover{
    transform: translateY(-1px);    
    background-position: 0 100%;
    transition: .3s ease-in-out;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, .4);
}

.btnSlidersDashboard{
    /* background: #1D8CF8; */
    background-size: 210% 210%;
    background-position: 100% 0;
    background-color: transparent;
    transition: all .15s ease;
    box-shadow: none;
    /* color: #fff; */
}

.text_btns{
    font-family: 'Poppins',sans-serif;
    font-size: 13px;
    font-weight: 400;
    margin: 5px;
    /* color: white; */
    color:  rgb(var(--v-theme-colorText));
}


.dashboard-card .v-btn--active .v-btn__overlay{
    background-color: rgb(var(--v-theme-btnSelect))!important;
}

/* .v-slide-group__next, .v-slide-group__prev{
    min-width: 0px !important;
} */

.dashboard-card{
    border: 2px solid rgba(var(--v-theme-colorBorder),0.1);
    border-radius: 20px;
 }

 .operability-card{
    border: 2px solid rgba(var(--v-theme-colorBorder),0.1);
 }

/* .dashboard-card .v-card-title{
    background-color:rgba(var(--v-theme-bgDashCard)) !important;
 } */

.card-dialogs{
    z-index: +3;
    background-color: rgba(var(--v-theme-blackAndWhite), 0.85) !important;
    border-radius: 20px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    max-height: 300px !important;
 }

.circular_btn:hover{
    cursor:pointer;
 }

.text_ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.alertNumber{
    margin: 10px auto;
    border-radius: 15px;
    color: black !important;
    padding: 7px 3px;
    transition: 0.5s;
}

.alertNumber:hover{
    cursor: pointer;
    transform: scale(1.1);
    transition: 0.5s;
}

.v-label--clickable, .v-selection-control__wrapper, .v-input__control, 
.v-slide-group__next, .v-slide-group__prev {    
    color: rgb(var(--v-theme-colorText)) !important;
}

.appBarComp .v-input__control{
    color: rgba(var(--v-theme-colorText)) !important;
}

.v-input__control .v-label{
    font-family: 'Poppins',sans-serif;
    font-size: 15px;
    color: rgb(var(--v-theme-colorText));
}

.v-slider .v-input__prepend, .v-slider .v-input__append{
    color: rgb(var(--v-theme-colorText)) !important;
}

.v-input__control .v-selection-control--density-default{
    min-height: 0px !important;
}
</style>